import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 * @param cancelToken - Token to cancel multiple requests
 * @returns - Array of Pro Images of type
 */

export const getProImages = async (params: any, headers?: any): Promise<any> => {
  try {
    let defaultHeaders = {
      "Content-Type": "application/json",
      "OSD-Module-Name": "proImages",
      "OSD-Action-Type": "list",
      "OSD-Exception-Number": params?.osdNumber
    };
    const response = await axios.post<any>(getUrl(ApiType.PRO_IMAGES), params, { headers: { ...defaultHeaders, ...headers } });
    return response.data;
  } catch (error) {
    throwApiError(error, ErrorMessages.proImage, { badRequestOrder: "errorsFirst" });
  }
};
